import { render } from "./client-service.vue?vue&type=template&id=67bc8244"
import script from "./client-service.vue?vue&type=script&lang=js"
export * from "./client-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__